import { getToken } from "../../Data/services/localStorageService";

export const getAuthorizationHeader = () => {
  const raw = getToken();
  if (!raw || raw === "undefined" || raw === "null") return null;

  const token = String(raw).trim();
  if (
    !token ||
    token === "Bearer" ||
    token === "Bearer undefined" ||
    token === "Bearer null"
  ) {
    return null;
  }

  return token.toLowerCase().startsWith("bearer ")
    ? token
    : `Bearer ${token}`;
};
